import { useQuery } from "@apollo/client/react"; import React, { useEffect, useMemo, useState } from 'react';
import { Grid } from '@mui/material';
import { RenderInputByTypeMobile } from '../../../../components/formGroupGenerator/RenderInputByTypeMobile';
import { getStringQueryCombosRI } from '../../../../data/graphQL/queries/ResumenIngreso/getAllCombosRI';
import { adaptCombosRIArray } from '../../../../adapters/resumenIngreso/combosRIAdapter';

import { obtenerDataImagen } from '../../../../actions/ImagenAction';

export const StepProgramaNPID = ({
  setDataSubmissionCallback,
  pantallas,
  updateFormData,
  fullFormDataRI
}) => {

  const [datosProgramaNPID, setDatosProgramaNPID] = useState(fullFormDataRI?.programaNPID1 ?? {});
  const [combosRI, setCombosRI] = useState();

  const inputCombos = inputsGroups.flatMap((inputgroup) => {
    return inputgroup.inputs.filter((input) => !!input.comboName);
  });
  const onDeleteImage = (inputName) => handleChange(inputName, null);

  useEffect(() => {
    setDatosProgramaNPID((prevData) => ({
      ...prevData,
      idPantallaRI: pantallas.find((p) => p.displayName.includes('NPID'))?.id
    }));
  }, [pantallas]);

  const { data: combosData } = useQuery(getStringQueryCombosRI(inputCombos));

  useEffect(() => {
    if (!combosData) return;

    setCombosRI(adaptCombosRIArray(combosData));
  }, [combosData]);

  const parsedInputsGroup = useMemo(() => {
    return inputsGroups.map((group) => ({
      ...group,
      inputs: group.inputs.map((input) => {
        if (!!input.comboName && !!combosRI) {
          input.options = combosRI[input.name];
        }
        if (input.name !== 'laboratorioAdjunto') return input;

        return {
          ...input,
          onDeleteImage: () => handleChange('laboratorioAdjunto', null)
        };

      })
    }));
  }, [combosRI]);


  useEffect(() => {
    setDataSubmissionCallback(handleSubmit);
  }, [datosProgramaNPID, setDataSubmissionCallback, parsedInputsGroup]);

  const handleSubmit = () => {
    updateFormData('programaNPID1', datosProgramaNPID, parsedInputsGroup.flatMap((x) => x.inputs));
  };

  const handleChange = (name, value) => {
    setDatosProgramaNPID((prevDatos) => ({
      ...prevDatos,
      [name]: value
    }));
  };

  const handleChangeImage = (name, value) => {
    obtenerDataImagen(value).then((image) => {
      handleChange(name,
        {
          contentType: image?.tipo,
          archivo: image?.data,
          extension: image?.extension,
          titulo: image?.nombre
        }
      );
    });
  };

  return (
    <div>
      {parsedInputsGroup.map((group) =>
        <>
          {group.notGrouped && <Grid container>
            {group.inputs.map((input) => {
              return (
                <RenderInputByTypeMobile
                  key={`${group.groupName}-${input.name}`}
                  grided
                  handleChange={handleChange}
                  input={input}
                  value={datosProgramaNPID[input.name]} />);


            })}
          </Grid>}
          {!group.notGrouped && <div className='step-form-section-container'>
            <label className={`step-form-section-title`}>
              {group.groupName}
            </label>
            <Grid contaier>
              {group.inputs.map((input) =>
                <RenderInputByTypeMobile
                  key={`${group.groupName}-${input.name}`}
                  grided
                  handleDelete={() => onDeleteImage(input.name)}
                  handleChange={input.name === 'laboratorioAdjunto' ? handleChangeImage : handleChange}
                  input={input}
                  value={datosProgramaNPID[input.name]} />

              )}
            </Grid>
          </div>}
        </>
      )}
    </div>);

};

const inputsGroups = [
  {
    notGrouped: true,
    groupName: 'Paciente Adulto',
    inputs: [
      {
        name: 'idComboRIValorKarnofsky',
        displayName: 'Karnofsky',
        comboName: 'Karnofsky',
        required: true,
        type: 'select'
      }]

  },
  {
    groupName: 'Requerimientos',
    inputs: [
      {
        name: 'proteinasTotales',
        displayName: 'Proteínas totales /d',
        required: true,
        type: 'float'
      },
      {
        name: 'lipidosTotales',
        displayName: 'Lípidos totales /d',
        required: true,
        type: 'float'
      },
      {
        name: 'caloriasTotales',
        displayName: 'Calorías totales /d',
        required: true,
        type: 'float'
      }]

  },
  {
    groupName: 'Examen Físico',
    inputs: [
      {
        name: 'presenciaEdemas',
        displayName: 'Presencia de edemas',
        required: true,
        type: 'boolean'
      }]

  },
  {
    groupName: 'Último laboratorio',
    inputs: [
      {
        name: 'laboratorio',
        displayName: 'Laboratorio',
        required: true,
        type: 'long_string'
      },
      {
        name: 'laboratorioAdjunto',
        displayName: 'Subir Laboratorio',
        required: true,
        type: 'file',
        validExtensions: ['PDF', 'PNG', 'JPG', 'HEIC', 'JPEG', 'JFIF'],
        maxFileSize: 8
      }]

  }];